import axios from 'axios';
import type { PartnerShopListAreasResponse, PartnerShopListResponse } from '@/types/partnerShop';

// async function requestApiData<T>(url: string, params?: Record<string, unknown>): Promise<T> {
//   const response = await axios.get(url, {
//     params,
//   });

//   const result = response.data;

//   if (!result || result.status !== 200) {
//     throw new Error(result?.message || '요청을 처리하지 못했습니다.');
//   }

//   return result.data as T;
// }

export async function getPartnerShopList(params: {
  categoryKey: string;
  page?: number;
  rows?: number;
  areaName?: string;
  areaNames?: string[];
  top3?: boolean | number | string;
}): Promise<{ status: number; data: PartnerShopListResponse; message?: string }> {
  const query: Record<string, unknown> = {
    page: params.page || 1,
    rows: params.rows || 50,
  };

  if (params.areaName && params.areaName !== '전체') {
    query.areaName = params.areaName;
  }

  if (params.areaNames && params.areaNames.length > 0) {
    query.areaNames = params.areaNames;
  }

  if (params.top3) {
    query.top3 = params.top3;
  }

  return axios.get(`/api/partner-shops/list/${params.categoryKey}`, {
    params: query,
  }).then(res => res.data);
}

export async function getPartnerTop3ListByCatogories () {
  return axios.get('/api/partner-shops/list/all-category')
    .then(res => res.data)
}

export async function getPartnerShopListAreas(categoryKey: string) {
  return axios.get(`/api/partner-shops/list/${categoryKey}/areas`)
    .then(res => res.data as { status: number; data: PartnerShopListAreasResponse; message?: string })
}
export async function getReviewPhotos({ shopSlug }) {
  return axios.get(`/api/partner-shops/${shopSlug}/photos`)
    .then(res => res.data)
}
export async function getReviewByPhotoId({shopSlug, photoId}) {
  return axios.get(`/api/partner-shops/${shopSlug}/photos/${photoId}`)
    .then(res => res.data)
}
